<template>
	<div v-show="active" class="guide-box flex-center">
		<div class="guide-dialog">
			<a class="close tf-cross" @click="active = false"></a>
			<img class="title" src="@/assets/image/guide/title.png" alt="">
			<img class="icon" src="@/assets/image/guide/icon.png" alt="">
			<div class="guide-main flex-center">
				<div v-if="!step" class="welcome flex-column flex-center">
					<p>让我30秒带您了解</p>
					<h1>如何发起生产工单流程?</h1>
					<c-button color="main" size="dialog" @click="step = 1">开始学习</c-button>
				</div>
				<video v-if="videoSrc" ref="video" :src="videoSrc" muted></video>
				<div v-if="tip" class="guide-tip" :style="{'left': `${tip.left}px`, 'top': `${tip.top}px`}">
					<div class="arrow"></div>
					<dl :style="{'top': `${tip.offset}px`}">
						<dt>{{tip.title}}</dt>
						<dd>
							<p>{{tip.message}}</p>
							<ul>
								<li v-for="(item, i) in tip.content" :key="i">{{item}}</li>
							</ul>
							<div class="button flex-end-center">
								<c-link color="red" @click="play">重播</c-link>
								<c-button color="red" size="normal" @click="step++">{{step == 4 ? '完成' : '下一步'}} ({{step}}/4)</c-button>
							</div>
						</dd>
					</dl>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {mapState} from 'vuex'

	export default {
		data() {
			return {
				active: false,
				step: 0,
				ended: false,
				videoUrl: {},
				tipData: [{
					top: 469,
					left: 5,
					offset: -130,
					title: '1. 基础数据配置【工艺路线】',
					message: '创建『工单』前，先进行基础数据配置',
					content: [
						'◎ 在『工艺路线』中，根据不同产品，定义生产相关工艺流程'
					]
				}, {
					top: 362,
					left: 5,
					offset: -100,
					title: '2. 基础数据配置【发布产品与物料】',
					message: '创建『工单』前，先进行基础数据配置',
					content: [
						'◎ 在『产品定义』中，创建需要生产的产品信息',
						'◎ 在『物料清单』中，进行【BOM】的创建与调整'
					]
				}, {
					top: 224,
					left: 5,
					offset: -100,
					title: '3. 生产管理【创建生产工单】',
					message: '系统以『工单』流转卡的形式，进行生产管理',
					content: [
						'◎ 基础数据填写好了之后，即可创建生产『工单』了',
						'◎ 标记工单『优先级』，可根据实际情况，是否优先生产',
						'◎ 列表上可查看每个『工序』的生产进度'
					]
				}, {
					top: 268,
					left: 5,
					offset: -100,
					title: '4. 报工',
					message: '每天工人下班之前，要把一天的生产量上报',
					content: [
						'◎工人可打开微信，扫工单二维码，扫码报工',
						'◎ 电脑端可在『报工工作台』，指定生产人员，代工人报工'
					]
				}]
			}
		},

		computed: {
			...mapState(['saasInfo']),

			videoSrc() {
				return this.step ? this.videoUrl[this.step] || require(`@/assets/image/guide/${this.step}.mp4`) : '';
			},

			tip() {
				return this.ended ? this.tipData[this.step - 1] : null;
			}
		},

		watch: {
			step(val) {
				if (val) {
					if (val > 4) {
						this.active = false;
						return;
					}
					this.$nextTick(this.play);
				}
			},

			active(val) {
				if (!val) {
					this.step = 0;
					this.ended = false;

					if (this.saasInfo.use_template_state == 2) {
						this.$confirm({
							type: 'warn',
							message: '首次使用系统需要选择应用一套行业方案',
							buttonName: '前往应用',
							cancelButton: false,
							resolve: () => {
								this.navigateTo('/system/factory');
							}
						});
					}
				}
			}
		},
		
		methods: {
			init() {
				this.step = 0;
				this.active = true;

				new Array(4).fill('').forEach((item, index) => {
					fetch(require(`@/assets/image/guide/${index + 1}.mp4`))
						.then(response => response.blob()) // 获取二进制数据
						.then(blob => {
							this.videoUrl[index + 1] = URL.createObjectURL(blob);
						}).catch(error => console.error('Error fetching video:', error));
				});
			},

			play() {
				this.ended = false;
				this.$refs.video.play();
				this.$refs.video.addEventListener('ended', () => {
					this.ended = true;
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	@keyframes guideIn {
		0% {
			opacity: 0;
		}

		100% {
			opacity: 1;
		}
	}

	@keyframes guideTipIn {
		0% {
			opacity: 0;
			transform: translate(40px,0);
		}

		100% {
			opacity: 1;
			transform: translate(0,0);
		}
	}

	.guide {
		&-box {
			z-index: 9999;
			position: fixed;
			inset: 0;
			background: rgba(0,0,0,.8);
			animation: guideIn .4s;
		}

		&-dialog {
			position: relative;
			box-sizing: border-box;
			width: 1000px;
			height: 708px;
			border-radius: 40px;
			padding: 118px 25px 26px;
			background: linear-gradient(0deg, #D8F6F1, #11B295);

			.close {
				position: absolute;
				right: -40px;
				top: 0px;
				font-size: 24px;
				color: #fff;
				opacity: .6;


				&:hover {
					opacity: 1;
				}
			}

			.title {
				position: absolute;
				left: 40px;
				top: 36px;
				height: 50px;
			}

			.icon {
				position: absolute;
				right: 0;
				top: -60px;
				height: 250px;
			}
		}

		&-main {
			position: relative;
			width: 100%;
			height: 100%;
			border-radius: 16px;
			overflow: hidden;

			.welcome {
				width: 100%;
				height: 100%;
				background: rgba(255,255,255,.9);

				p {
					font-size: 24px;
				}

				h1 {
					margin: 20px 0 24px;
					font-size: 30px;
					background: linear-gradient(90deg, #FF5555 0%, #2500DF 100%);
					-webkit-background-clip: text;
					-webkit-text-fill-color: transparent;
				}
			}

			video {
				width: 100%;
				height: 100%;
				background: #000;
				object-fit: fill;
			}
		}

		&-tip {
			position: absolute;
			width: 112px;
			height: 22px;
			box-shadow: 0 0 0 9999px rgba(0,0,0,.6);
			animation: guideIn .8s;

			.arrow {
				position: absolute;
				left: calc(100% - 10px);
				top: 50%;
				width: 98px;
				border-top: 2px dashed #FFD800;
				opacity: 0;
				animation: guideTipIn .4s forwards;
				animation-delay: .6s;

				&:before {
					content: '';
					position: absolute;
					left: -8px;
					top: -7px;
					border-right: 8px solid #FFD800;
					border-top: 6px solid rgba(0,0,0,0);
					border-bottom: 6px solid rgba(0,0,0,0);
				}
			}

			dl {
				position: absolute;
				left: calc(100% + 90px);
				top: 0;
				box-sizing: border-box;
				width: 420px;
				border-radius: 6px;
				padding: 0 20px 20px 30px;
				background: linear-gradient(180deg, #EAFFFA, #FFFFFF);
				opacity: 0;
				animation: guideTipIn .4s forwards;
				animation-delay: .6s;

				dt {
					line-height: 70px;
					font-size: 18px;
					font-weight: bold;
				}

				dd {
					p {
						font-size: 14px;
						color: #666;
					}

					ul {
						margin-top: 10px;

						li {
							line-height: 26px;
							font-size: 14px;
							color: #111;
						}
					}

					.button {
						margin-top: 20px;

						>>> .c-link {
							margin-right: 20px;
						}
					}
				}
			}
		}
	}
</style>
